import UXCatPageTitle from './UXCatPageTitle';

export default UXCatPageTitle;
